import React from 'react';
import { Card, CardContent, Typography, Box, Divider, styled, Avatar, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getLongDateWithYear } from '../../utils/commonMethods';
import { Task } from '../../interfaces/TaskOverview'
import LocalStorageUtil from '../../utils/localStorageUtil';
import { storageKeys } from '../../utils/constants';
import { getAppName } from '../../utils/commonMethods';
import { getTenantConfig } from '../../tenantConfig';
import { AssignmentTurnedInRounded } from '@mui/icons-material';
import ProtocolIcon from '../../assets/Protocol_Icon.svg?react';
import { useTimerContext } from '../../contexts/TimerContext';
import DateIcon from '../../assets/date_Icon.svg?react';
import LocationIcon from '../../assets/location_Icon.svg?react';
import MaterialIcon from '../../assets/material_Icon.svg?react';

export const StyledAvatarMobile = styled(Avatar)(({ theme, }) => ({
    width: "24px",
    height: "24px",
    backgroundColor: theme.palette.blueColors.main,
    fontSize: '10px',
}))
interface MobileTaskCardProps {
    task: Task;
    layerData: Record<string, any>;
}

const MobileTaskCard: React.FC<MobileTaskCardProps> = ({ task, layerData }) => {
    const userName = LocalStorageUtil.getItem(storageKeys.userName, "");
    const appName = getAppName();
    const iconColor = getTenantConfig(appName).taskIconColor;

    const tableCardMobileStyle = {
        fontSize: '14px',
        fontFamily: 'Nunito Sans SemiBold',
        lineHeight: '19.1px',
        color: '#696868'
    };

    // Helper function to get protocol name from layerData
    const getProtocolName = (layerId: number) => {
        const layer = layerData?.[layerId];
        return layer?.protocol_name || "-";
    };

    const navigate = useNavigate();
    const theme = useTheme();
    const { setSelectedProjectIdForNavigation } = useTimerContext()
    return (
        <Card
            onClick={() => {
                if (task?.is_static) return;
                setSelectedProjectIdForNavigation(task.project_id)
                navigate(`/taskdetail/${task?.id}`);
            }}
            sx={{
                margin: 2,
                paddingLeft: 0,
                marginBottom: 0,
                borderRadius: "5px",
                backgroundColor: '#FFFFFF',
                border: '0.5px solid rgba(0, 0, 0, 0.1)',
            }}
        >
            <CardContent
                sx={{
                    padding: 0,
                    "&:last-child": {
                        paddingBottom: 2
                    }
                }}
            >
                <Box
                    borderColor="rgba(0, 0, 0, 0.25)"
                    paddingX={1}
                    paddingY={1}
                    sx={{ display: "flex", flexDirection: "row", minHeight: 35, alignItems: "center" }}
                >
                    {!task?.medewerker_level &&
                        <AssignmentTurnedInRounded fontSize='medium' sx={{ color: iconColor }} />
                    }
                    <Typography sx={{
                        fontFamily: 'Nunito Sans Bold',
                        fontSize: '16px',
                        // lineHeight: '32px',
                        color: '#696868',
                        ml: 1
                    }}>
                        {task?.task_name}
                    </Typography>
                </Box>

                <Divider sx={{ backgroundColor: theme.palette.primary.light, height: '1px', mb: 1 }} />

                {/* {task?.remarks && (
                    <Box sx={{ ml: 2, mr: 2, mb: 1 }}>
                        <Typography sx={{
                            fontFamily: 'Nunito Sans SemiBold',
                            fontSize: '12px',
                            color: '#696868',
                            fontStyle: 'italic'
                        }}>
                            PM: {task.remarks}
                        </Typography>
                    </Box>
                )} */}

                <Box sx={{
                    ml: 2,
                    mr: 2,
                }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    }}>
                        <Box>
                            {/* <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                pb: 2
                            }}>
                                <FaunaIcon
                                    style={{ 
                                        width: 20, 
                                        height: 22.52, 
                                        marginRight: 10,
                                        color: iconColor
                                    }}
                                />
                                <Typography sx={tableCardMobileStyle}>
                                    {task?.fauna_type_name}
                                </Typography>
                            </Box> */}

                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', pb: 2 }}>
                                <ProtocolIcon
                                    style={{
                                        width: 20,
                                        height: 22.52,
                                        marginRight: 10,
                                        color: iconColor,
                                    }}
                                />
                                <Typography sx={tableCardMobileStyle}>
                                    {getProtocolName(task?.layer_id)}
                                </Typography>
                            </Box>


                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                pb: 2
                            }}>
                                <DateIcon
                                    style={{
                                        width: 20,
                                        height: 22.52,
                                        marginRight: 10,
                                        color: iconColor
                                    }}
                                />
                                <Typography sx={tableCardMobileStyle}>
                                    {getLongDateWithYear(task?.start_date)}
                                    {/* {task?.from_time && ` ${task.from_time.substring(0, 5)}`} */}
                                </Typography>
                            </Box>

                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                pb: 2
                            }}>
                                <MaterialIcon
                                    style={{
                                        width: 20,
                                        height: 22.52,
                                        marginRight: 10,
                                        color: iconColor
                                    }}
                                />
                                <Typography sx={{
                                    ...tableCardMobileStyle,
                                    display: '-webkit-box',
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    WebkitLineClamp: 1,
                                    textOverflow: 'ellipsis',
                                    wordBreak: 'break-all',
                                }}>
                                    {task?.materials}
                                </Typography>
                            </Box>

                        </Box>

                        <Box>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                pb: 2
                            }}>
                                <LocationIcon
                                    style={{
                                        width: 20,
                                        height: 22.52,
                                        marginRight: 10,
                                        color: iconColor
                                    }}
                                />
                                <Typography sx={tableCardMobileStyle}>
                                    {task?.address}
                                </Typography>
                            </Box>

                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                pb: 2
                            }}>
                                <DateIcon
                                    style={{
                                        width: 20,
                                        height: 22.52,
                                        marginRight: 10,
                                        color: iconColor
                                    }}
                                />
                                <Typography sx={tableCardMobileStyle}>
                                    {getLongDateWithYear(task?.end_date)}
                                    {/* {task?.to_time && ` ${task.to_time.substring(0, 5)}`} */}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default MobileTaskCard;